import { AxiosError, CancelToken } from 'axios';

import { LoggerType } from '@services/errorService';
import { IUrlParams } from '@utils/text';

export enum httpMethods {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}

export enum EHttpClient {
  CHECKOUT_GATEWAY = 'checkout_gateway',
  PARFUMS = 'parfums',
}

export interface IRequestParam<TParam = null> {
  data?: TParam;
  restUrlParams?: IUrlParams[];
  queryUrlParams?: IUrlParams[];
  cancelToken?: CancelToken;
}

export interface IUseHttpClientParams<TResult, TRequestResult = TResult> {
  method: httpMethods;
  path: string;
  mappingFunction?: (param: TRequestResult, callLogger: LoggerType) => TResult | null;
  customHeaders?: IHeader[];
  httpClientType?: EHttpClient;
  requestRetryCount?: number;
}

interface IHttpClientResponseBase<TResult> {
  response: TResult | null;
  error: string[];
  loading: boolean;
}

export interface IHttpClientResponseAwaitable<TResult, TParam = null> {
  request: (params?: IRequestParam<TParam>) => Promise<TResult | null>;
}

export interface IHttpClientResponse<TResult, TParam = null> extends IHttpClientResponseBase<TResult> {
  request: (params?: IRequestParam<TParam>) => Promise<void>;
}

export interface IHttpHookResponseAwaitable<TResult, TInput = null> {
  request: (params?: TInput) => Promise<TResult | null>;
}

export interface IHttpHookResponse<TResult, TInput = null> extends IHttpClientResponseBase<TResult> {
  request: (params?: TInput) => Promise<void>;
}

export interface IGraphQlQuery {
  query: string;
}

export interface IGraphQLMutationObject<P> {
  query: string;
  variables?: IGraphQLVariables<P>;
}

export interface IGraphQLMutationPrimitive<P> {
  query: string;
  variables?: P;
}

export interface IGraphQLVariables<P> {
  [payload: string]: P;
}

export interface IGeneralRequestResponse<T> {
  data: T;
  messages: string[];
  reasonKeys?: string[];
  localizedErrorMessages?: string[];
}

export interface IHeader {
  [name: string]: string;
}

export interface IHttpClientError extends Error {
  code: number;
}

export interface AxiosErrorExtended extends AxiosError {
  request: { status: number };
}
